module.exports = __webpack_public_path__ + "assets/d64225a3584d36129d6f99b59819f296.png";